export type {
  PopoverSurfaceSlots as TeachingPopoverSurfaceSlots,
  PopoverSurfaceProps as TeachingPopoverSurfaceProps,
  PopoverSurfaceState as TeachingPopoverSurfaceState,
} from '../../Popover/PopoverSurface/PopoverSurface.types';
